/**
 * Dev-only "feature under test" banner.
 *
 * Inert by default: renders NOTHING unless the Vite env var
 * `VITE_FEATURE_UNDER_TEST` is a non-empty string. When the `/feature-demo`
 * skill boots the local demo it writes `VITE_FEATURE_UNDER_TEST=🧪 Probando:
 * <feature>` into the untracked `packages/web/.env.local`, and this strip
 * surfaces that label at the top of every route so it's obvious which feature
 * a local demo is exercising.
 *
 * The text is rendered VERBATIM from the env var — no hardcoded copy — so the
 * skill fully controls the message.
 */
export function FeatureDemoBanner() {
  const label = import.meta.env.VITE_FEATURE_UNDER_TEST?.trim();
  if (!label) return null;

  return (
    <div
      role="status"
      className="fixed inset-x-0 top-0 z-[100] flex h-6 items-center justify-center bg-primary px-3 text-center font-mono text-[11px] font-medium tracking-wide text-white shadow-sm"
    >
      <span className="truncate">{label}</span>
    </div>
  );
}
